<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger
      class="hamburger-container"
      :toggleClick="toggleSideBar"
      :isActive="sidebar.opened"
    ></hamburger>
    <breadcrumb class="breadcrumb-container"></breadcrumb>
    <div class="right-menu">
      <!-- <div class="setup-btn" @click="setupStep = 1">Get Start</div> -->
      <el-tooltip effect="dark" content="全屏" placement="bottom">
        <screenfull class="screenfull right-menu-item"></screenfull>
      </el-tooltip>
      <el-dropdown
        trigger="click"
        class="international"
        @command="handleSetLanguage"
      >
        <div>
          <svg-icon
            class-name="right-menu-item international-icon"
            icon-class="language"
          />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="zh" :disabled="language === 'zh'"
            >中文</el-dropdown-item
          >
          <el-dropdown-item command="en" :disabled="language === 'en'"
            >English</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img
            class="user-avatar"
            src="/static/img/admin.png"
            v-if="this.userDetails.wechat_auth_id === 0"
          />
          <img
            class="user-avatar"
            :src="
              this.userWechatDetails.headimgurl +
              '?imageView2/1/w/200/h/200/q/75|imageslim'
            "
            v-else
          />
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <el-dropdown-item>
            <el-popover
              placement="bottom-end"
              width="170"
              visible-arrow
              v-model="qrcode"
              trigger="click"
            >
              <div class="qrcode">
                <canvas id="qrccode-canvas"></canvas>
                <el-button size="mini" @click="refresh()">刷新</el-button>
              </div>
              <span
                @click="wechatBindLink()"
                style="display: block"
                slot="reference"
                v-if="this.userDetails.wechat_auth_id === 0"
                >微信绑定</span
              >
              <!-- <span @click="wechatBindLink()" style="display:block;" slot="reference" v-else>已绑定</span> -->
            </el-popover>
          </el-dropdown-item>
          <el-dropdown-item v-if="this.userDetails.wechat_auth_id !== 0">
            <el-popover
              placement="left"
              width="200"
              visible-arrow
              v-model="unbindVisible"
            >
              <p style="font-weight: bold">确定解除微信绑定？</p>
              <div style="text-align: right; margin: 0">
                <el-button
                  size="mini"
                  type="text"
                  @click="unbindVisible = false"
                  >取消</el-button
                >
                <el-button type="primary" size="mini" @click="wechatUnbind()"
                  >确定</el-button
                >
              </div>
              <span style="display: block" slot="reference">微信解绑</span>
            </el-popover>
          </el-dropdown-item>
          <el-dropdown-item>
            <span @click="logout" style="display: block">LogOut</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog
      :visible="setupStep > 0"
      :close-on-press-escape= 'false'
      width="78%"
      @close="setupStep = 0"
    >
      <setup-basic-info
        v-show="setupStep == 1"
        @update="updatedBasicInfo"
        @forbid="expireReminder"
      />

      <setup-modules
        v-show="setupStep == 2"
        @go-back="setupStep = 1"
        @go-next="setupStep = 3"
        @close="closeSetupDialog"
      />

      <setup-payments
        v-show="setupStep == 3"
        @close="closeSetupDialog"
        @forbid="expireReminder"
      />

    </el-dialog>
  </el-menu>
</template>

<script>
import request from '@/utils/request'
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import SetupBasicInfo from '@/components/SetupSteps/SetupBasicInfo'
import SetupModules from '@/components/SetupSteps/SetupModules'
import SetupPayments from '@/components/SetupSteps/SetupPayments'
import { generateCustomizeString } from '@/utils/i18n'
import QRCode from 'qrcode'
import cookie from 'js-cookie'

var canvas = ''

export default {
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
    SetupBasicInfo,
    SetupModules,
    SetupPayments
  },
  data() {
    return {
      wechatLinkData: [],
      userDetails: [],
      userWechatDetails: [],
      userWechatInfo: [],
      qrcode: false,
      unbindVisible: false,
      setupStep: 0
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'language'])
  },
  mounted() {
    this.$nextTick(function() {
      // DOM操作
      canvas = document.getElementById('qrccode-canvas')
    })
  },
  methods: {
    generateCustomizeString,
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('setLanguage', lang)
      this.$message({
        message: this.generateCustomizeString('switchLanguageSuccess'),
        type: 'success'
      })
    },
    logout() {
      cookie.remove('globalMenu')
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    createQrcode() {
      this.qrcode = true
      const qrcodeLink = this.wechatLinkData.link
      QRCode.toCanvas(canvas, qrcodeLink, (error) => {
        if (error) {
          console.log(error)
        } else {
          console.log('success')
        }
      })
    },
    wechatBindLink() {
      request({
        url: '/admin/wx/bind/link',
        method: 'get'
      })
        .then((response) => {
          this.wechatLinkData = response.data
        })
        .catch((error) => {
          console.warn(error)
        })
        .finally(() => {
          this.createQrcode()
        })
    },
    wechatUnbind() {
      this.unbindVisible = false
      request({
        url: '/admin/wx/unbind',
        method: 'post'
      })
        .then((response) => {
          if (response.status === 0) {
            this.$message({
              message: '微信解除绑定成功',
              type: 'success'
            })
          }
        })
        .catch((error) => {
          console.warn(error)
        })
        .finally(() => {
          this.fetchUser()
        })
    },
    redirectToSettings() {
      this.setupStep = 0
      this.$router.push({ name: 'ShopDetail' })
    },
    closeSetupDialog() {
      this.setupStep = 0
    },
    expireReminder() {
      request({
        url: '/admin/expire-self-create-shop-reminder',
        method: 'put'
      }).then((res) => {
        if (res.status === 0) {
          this.setupStep = 0
        }
      })
    },
    getSelfCreateShopReminder() {
      // 获取开店指南提示
      request({
        url: '/admin/get-self-create-shop-reminder',
        method: 'get'
      }).then((res) => {
        if (res.data.length <= 0) {
          return
        }
        this.setupStep = 1
      })
    },
    refresh() {
      this.qrcode = false
      this.fetchUser()
    },
    fetchUser() {
      request({
        url: '/user',
        method: 'get'
      })
        .then((response) => {
          this.userDetails = response.data
          if (
            response.data.wechat_auth &&
            response.data.wechat_auth.user_info
          ) {
            this.userWechatDetails = response.data.wechat_auth.user_info
          }
        })
        .catch((error) => {
          console.warn(error)
        })
    },
    fetchUserInfo() {
      request({
        url: '/admin/wx/info',
        method: 'get'
      })
        .then((response) => {
          this.userWechatInfo = response.data
        })
        .catch((error) => {
          console.warn(error)
        })
    },
    updatedBasicInfo() {
      this.setupStep = 2
    }
  },
  created() {
    this.fetchUser()
    // this.getSelfCreateShopReminder()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .breadcrumb-container {
    float: left;
  }
  .screenfull {
    height: 20px;
  }
  .right-menu {
    float: right;
    height: 100%;
    display: flex;
    align-items: center;
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
    .setup-btn {
      width: 108px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: #2979ff;
      color: #fff;
      border-radius: 16px;
      cursor: pointer;
    }
    .screenfull {
      height: 20px;
    }
    .international {
      .international-icon {
        font-size: 20px;
        cursor: pointer;
      }
    }
    .avatar-container {
      height: 50px;
      margin-right: 30px;
      .avatar-wrapper {
        cursor: pointer;
        margin-top: 5px;
        position: relative;
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
.qrcode {
  width: 150px;
  height: 180px;
  text-align: center;
}
.qrcode canvas {
  width: 150px !important;
  height: 150px !important;
}
</style>

